import React, { Component } from "react";
import {
  profile,
  toFixed,
  format_date,
  GET,
  loading,
  DateRangePicker,
  Navbar,
  copyText,
} from "../../components/CustomComponent.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import Countup from "react-countup";
const color = [
  "255, 99, 132", // Red
  "54, 162, 235", // Blue
  "255, 206, 86", // Yellow
  "75, 192, 192", // Teal
  "153, 102, 255", // Purple
  "255, 159, 64", // Orange
  "199, 199, 199", // Gray
  "255, 99, 71", // Tomato
  "60, 179, 113", // Medium Sea Green
  "123, 104, 238", // Medium Slate Blue
  "255, 105, 180", // Hot Pink
  "0, 191, 255", // Deep Sky Blue
  "46, 139, 87", // Sea Green
  "255, 215, 0", // Gold
  "70, 130, 180", // Steel Blue
  "218, 112, 214", // Orchid
  "244, 164, 96", // Sandy Brown
  "0, 128, 128", // Teal Dark
  "205, 92, 92", // Indian Red
  "112, 128, 144", // Slate Gray
];
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_broker: [],
      data_customer: [],
      data_deposits: [],
      data_withdrawals: [],

      tab: "day",

      count_broker: 0,
      count_customer: 0,
      today_broker: 0,
      today_customer: 0,
      amount_mismatch: 0,
      count_mismatch: 0,

      deposit: null,
      withdrawal: null,
      mismatch: null,
      refund: null,

      chart_deposit: null,
      chart_withdrawal: null,
      chart_broker: null,

      filter_start_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        "yyyy-MM-dd",
        "en",
      ),
      filter_end_date: format_date(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
        "yyyy-MM-dd",
        "en",
      ),
      filter_currency: "THB",
      array_date: [],
    };
    this.intv = null;
  }

  async componentDidMount() {
    ChartJS.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      BarElement,
      Title,
      Tooltip,
      Legend,
    );
    loading(false);
    await this.Get();
    this.intv = setInterval(() => {
      this.Get(true);
    }, 20000);
  }
  componentWillUnmount() {
    if (this.intv) {
      clearInterval(this.intv);
      this.intv = null;
    }
  }

  Get = async (load) => {
    const { filter_start_date, filter_end_date, filter_currency } = this.state;
    if (!load) {
      loading(true);
    }
    let data_broker,
      data_customer,
      count_broker,
      count_customer,
      today_broker,
      today_customer,
      deposit,
      withdrawal,
      mismatch,
      refund,
      chart_deposit,
      chart_withdrawal,
      chart_broker;
    let _date_start = format_date(filter_start_date, "yyyy-MM-dd", "en");
    let _date_end = format_date(filter_end_date, "yyyy-MM-dd", "en");
    let _array_date = [];
    let current = new Date(_date_start);

    while (current <= new Date(_date_end)) {
      _array_date.push(format_date(current, "dd/MM"));
      current.setDate(current.getDate() + 1); // เพิ่มทีละวัน
    }

    let [
      result_broker,
      result_customer,
      result_gmv,
      result_chart,
      result_chart_broker,
    ] = await Promise.all([
      GET("v1/admin/dashboards/broker", null),
      GET("v1/admin/dashboards/customer", { currency: filter_currency }),
      GET("v1/admin/dashboards/gmv", {
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        currency: filter_currency,
      }),
      GET("v1/admin/dashboards/chart-gmv", {
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        currency: filter_currency,
      }),
      GET("v1/admin/dashboards/chart-gmv/broker", {
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        currency: filter_currency,
      }),
    ]);

    if (result_broker?.status) {
      data_broker = result_broker?.data?.top10_brokers;
      count_broker = result_broker?.data?.total_brokers;
      today_broker = result_broker?.data?.today_broker;
    }
    if (result_customer?.status) {
      data_customer = result_customer?.data?.top10_customers;
      count_customer = result_customer?.data?.total_customers;
      today_customer = result_customer?.data?.today_customer;
    }
    if (result_gmv?.status) {
      deposit = result_gmv?.data?.deposit;
      withdrawal = result_gmv?.data?.withdrawals;
      mismatch = result_gmv?.data?.mismatch;
      refund = result_gmv?.data?.refund;
    }
    if (result_chart?.status) {
      chart_deposit = result_chart?.data?.deposit;
      chart_withdrawal = result_chart?.data?.withdrawals;
    }
    if (result_chart_broker?.status) {
      chart_broker = result_chart_broker.data;
    }
    this.setState({
      data_broker,
      data_customer,
      count_broker,
      count_customer,
      today_broker,
      today_customer,

      deposit,
      refund,
      withdrawal,
      mismatch,

      chart_deposit,
      chart_withdrawal,

      chart_broker,

      array_date: _array_date,
    });
    loading(false);
  };
  render() {
    const {
      filter_start_date,
      filter_end_date,
      filter_currency,
      data_broker,
      count_broker,
      data_customer,
      count_customer,
      today_broker,
      today_customer,

      deposit,
      withdrawal,
      mismatch,
      refund,

      chart_deposit,
      chart_withdrawal,

      chart_broker,

      array_date,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* Header: หัว hero + Filter (ช่วงวันที่ / สกุลเงิน) */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Overview</div>
                <div className="ar-title">Dashboard</div>
                <div className="ar-subtitle">
                  Welcome back, {profile?.full_name}! Here's your{" "}
                  {profile?.user_type.replaceAll("_", " ")} overview.
                </div>
              </div>
            </div>
            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{"\uf0b0"}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field">
                  <span className="ar-filter-label">Period</span>
                  <div className="wpx-230">
                    <DateRangePicker
                      className="form-control"
                      onChange={(e) => {
                        this.setState(
                          {
                            filter_start_date: e.start_date,
                            filter_end_date: e.end_date,
                          },
                          () => {
                            if (
                              this.state.filter_start_date &&
                              this.state.filter_end_date
                            ) {
                              this.Get();
                            }
                          },
                        );
                      }}
                      value={{
                        start_date: filter_start_date,
                        end_date: filter_end_date,
                      }}
                      max={filter_end_date}
                    />
                  </div>
                </div>
              </div>
              <div className="ar-filter-foot">
                {global.currency?.map((item) => (
                  <button
                    type="button"
                    key={item.currency_code}
                    className={`ar-pill ${item.currency_code === filter_currency ? "active" : ""}`}
                    onClick={() => {
                      this.setState(
                        { filter_currency: item.currency_code },
                        () => this.Get(),
                      );
                    }}
                  >
                    {item.image}
                    <span className="ms-1">{item.currency_name}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6 col-md-3 mb-3">
              <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                <div className="w-100">
                  <small className="text-secondary text-nowrap">
                    Mismatched Orders
                  </small>
                  <h5 className="fw-bold mb-0">
                    <Countup
                      start={0}
                      end={mismatch?.amount || 0}
                      duration={2}
                      separator=","
                    />
                  </h5>
                  <div
                    style={{ marginTop: -2, height: 15 }}
                    className="text-12 text-primary"
                  >
                    <Countup
                      start={0}
                      end={mismatch?.count || 0}
                      duration={2}
                      separator=","
                    />{" "}
                    Orders
                  </div>
                </div>
                <span className="icon text-danger">{"\uf05e"}</span>
              </div>
            </div>
            {["super_user", "admin"]?.includes(profile?.user_type) && (
              <div className="col-12 col-sm-6 col-md-3 mb-3">
                <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                  <div className="w-100">
                    <small className="text-secondary text-nowrap">
                      Brokers
                    </small>
                    <h5 className="fw-bold mb-0">
                      <Countup
                        start={0}
                        end={count_broker}
                        duration={2}
                        separator=","
                      />
                    </h5>
                    <div
                      style={{ marginTop: -2, height: 15 }}
                      className={`text-12 ${
                        today_broker > 0 ? "text-success" : "text-secondary"
                      }`}
                    >
                      {today_broker > 0 ? <>+{today_broker} Today </> : ""}
                    </div>
                  </div>
                  <span className="icon text-info">{"\uf007"}</span>
                </div>
              </div>
            )}
            <div className="col-12 col-sm-6 col-md-3 mb-3">
              <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                <div className="w-100">
                  <small className="text-secondary text-nowrap">
                    Customers
                  </small>
                  <h5 className="fw-bold mb-0">
                    <Countup
                      start={0}
                      end={count_customer}
                      duration={2}
                      separator=","
                    />
                  </h5>
                  <div
                    style={{ marginTop: -2, height: 15 }}
                    className={`text-12 ${
                      today_customer > 0 ? "text-success" : "text-secondary"
                    }`}
                  >
                    {today_customer > 0 ? (
                      <>
                        +
                        <Countup
                          start={0}
                          end={today_customer}
                          duration={2}
                          separator=","
                        />{" "}
                        Today{" "}
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <span className="icon text-purple">{"\uf007"}</span>
              </div>
            </div>
            <div
              className={
                ["super_user", "admin"].includes(profile?.user_type)
                  ? "col-12 col-sm-6 col-md-3 mb-3"
                  : "col-12 col-sm-6 mb-3"
              }
            >
              <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                <div className="w-100">
                  <small className="text-secondary text-nowrap">
                    Total Refund Amount
                  </small>
                  <h5 className="fw-bold mb-0">
                    <Countup
                      start={0}
                      end={Number(refund?.amount)}
                      duration={2}
                      separator=","
                    />{" "}
                    <span className="text-16">{filter_currency}</span>
                  </h5>
                  <div
                    style={{ marginTop: -2, height: 15 }}
                    className="text-12 text-light"
                  >
                    .
                  </div>
                </div>
                <span className="icon text-info">{"\uf0d6"}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="row">
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Deposits Amount
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.amount)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-primary"
                      >
                        <Countup
                          start={0}
                          end={Number(deposit?.count || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        Orders |{" "}
                        <span className="text-success">
                          +
                          <Countup
                            start={0}
                            end={Number(deposit?.today_count)}
                            duration={2}
                            separator=","
                          />{" "}
                          | +
                          <Countup
                            start={0}
                            end={Number(deposit?.today_amount || 0)}
                            duration={2}
                            separator=","
                          />{" "}
                          {filter_currency}
                        </span>
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf0d6"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Deposits Fee
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.fee)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-success"
                      >
                        +
                        <Countup
                          start={0}
                          end={Number(deposit?.today_fee || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        {filter_currency}
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf53b"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Deposits Net
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.amount_net || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-success"
                      >
                        +
                        <Countup
                          start={0}
                          end={Number(deposit?.today_amount_net)}
                          duration={2}
                          separator=","
                        />{" "}
                        {filter_currency}
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf53d"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Deposits (AOV)
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(deposit?.average)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-success">{"\uf53d"}</span>
                  </div>
                </div>
              </div>
              <div className="ar-table-card">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf201"}
                      </span>
                      Monthly Deposits
                    </div>
                    <div className="ar-table-caption">
                      Deposit trends between {format_date(filter_start_date)} -{" "}
                      {format_date(filter_end_date)}
                    </div>
                  </div>
                </div>
                <div className="ar-chart" style={{ height: 340 }}>
                  <Line
                    datasetIdKey="id"
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                    data={{
                      labels: array_date,
                      datasets: [
                        {
                          id: 1,
                          label: "Amount",
                          data:
                            chart_deposit?.chart_amount?.map((e) => e.value) ||
                            [],
                          backgroundColor: "rgba(75, 192, 192, 0.2)",
                          borderColor: "rgba(75, 192, 192, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 2,
                          label: "Fee",
                          data:
                            chart_deposit?.chart_fee?.map((e) => e.value) || [],
                          backgroundColor: "rgba(255, 99, 132, 0.2)",
                          borderColor: "rgba(255, 99, 132, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 3,
                          label: "VAT",
                          data:
                            chart_deposit?.chart_vat?.map((e) => e.value) || [],
                          backgroundColor: "rgba(255, 206, 86, 0.2)",
                          borderColor: "rgba(255, 206, 86, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 4,
                          label: "Amount Net",
                          data:
                            chart_deposit?.chart_amount_net?.map(
                              (e) => e.value,
                            ) || [],
                          backgroundColor: "rgba(153, 102, 255, 0.2)",
                          borderColor: "rgba(153, 102, 255, 1)",
                          borderWidth: 2,
                        },
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 mb-3">
              <div className="row">
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Withdrawals Amount
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.amount || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-primary"
                      >
                        {withdrawal?.count || 0} Orders |{" "}
                        <span className="text-success">
                          +
                          <Countup
                            start={0}
                            end={Number(withdrawal?.today_count || 0)}
                            duration={2}
                            separator=","
                          />{" "}
                          | +
                          <Countup
                            start={0}
                            end={Number(withdrawal?.today_amount || 0)}
                            duration={2}
                            separator=","
                          />{" "}
                          {filter_currency}
                        </span>
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf0d6"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Withdrawals Fee
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.fee || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-success"
                      >
                        +
                        <Countup
                          start={0}
                          end={Number(withdrawal?.today_fee || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        {filter_currency}
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf53b"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Total Withdrawals Net
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.amount_net)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-success"
                      >
                        +
                        <Countup
                          start={0}
                          end={Number(withdrawal?.today_amount_net || 0)}
                          duration={2}
                          separator=","
                        />{" "}
                        {filter_currency}
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf53d"}</span>
                  </div>
                </div>
                <div className="col-12 col-xxl-6 mb-3">
                  <div className="ar-kpi db-kpi d-flex justify-content-between align-items-start">
                    <div className="w-100">
                      <small className="text-secondary text-nowrap">
                        Withdrawals (AOV)
                      </small>
                      <h5 className="fw-bold mb-0">
                        <Countup
                          start={0}
                          end={Number(withdrawal?.average)}
                          duration={2}
                          separator=","
                        />{" "}
                        <span className="text-16">{filter_currency}</span>
                      </h5>
                      <div
                        style={{ marginTop: -2, height: 15 }}
                        className="text-12 text-light"
                      >
                        .
                      </div>
                    </div>
                    <span className="icon text-warning">{"\uf53d"}</span>
                  </div>
                </div>
              </div>
              <div className="ar-table-card">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf201"}
                      </span>
                      Monthly Withdrawals
                    </div>
                    <div className="ar-table-caption">
                      Withdrawal trends between {format_date(filter_start_date)}{" "}
                      - {format_date(filter_end_date)}
                    </div>
                  </div>
                </div>
                <div className="ar-chart" style={{ height: 340 }}>
                  <Line
                    datasetIdKey="id"
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                    }}
                    data={{
                      labels: array_date,
                      datasets: [
                        {
                          id: 1,
                          label: "Amount",
                          data:
                            chart_withdrawal?.chart_amount?.map(
                              (e) => e.value,
                            ) || [],
                          backgroundColor: "rgba(75, 192, 192, 0.2)",
                          borderColor: "rgba(75, 192, 192, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 2,
                          label: "Fee",
                          data:
                            chart_withdrawal?.chart_fee?.map((e) => e.value) ||
                            [],
                          backgroundColor: "rgba(255, 99, 132, 0.2)",
                          borderColor: "rgba(255, 99, 132, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 3,
                          label: "VAT",
                          data:
                            chart_withdrawal?.chart_vat?.map((e) => e.value) ||
                            [],
                          backgroundColor: "rgba(255, 206, 86, 0.2)",
                          borderColor: "rgba(255, 206, 86, 1)",
                          borderWidth: 2,
                        },
                        {
                          id: 4,
                          label: "Amount Net",
                          data:
                            chart_withdrawal?.chart_amount_net?.map(
                              (e) => e.value,
                            ) || [],
                          backgroundColor: "rgba(153, 102, 255, 0.2)",
                          borderColor: "rgba(153, 102, 255, 1)",
                          borderWidth: 2,
                        },
                      ],
                    }}
                  />
                </div>
              </div>
            </div>
            {["super_user", "admin"].includes(profile?.user_type) && (
              <div className="col-12 mb-3">
                <div className="ar-table-card h-100">
                  <div className="ar-table-head flex-wrap gap-2">
                    <div>
                      <div className="ar-table-title">
                        <span className="icon me-2 pu-title-icon">
                          {"\uf155"}
                        </span>
                        Broker Deposits
                      </div>
                      <div className="ar-table-caption">
                        Total deposits made by each broker over the selected
                        period
                      </div>
                    </div>
                  </div>

                  <div className="ar-chart" style={{ height: 440 }}>
                    <Bar
                      datasetIdKey="id"
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                      }}
                      data={{
                        labels: array_date,
                        datasets: data_broker?.map((b, i) => {
                          return {
                            id: 1,
                            label: b.name_en,
                            data:
                              chart_broker
                                ?.find((d) => d.label === b.name_en)
                                ?.chart_deposit?.map((e) => e.value) || [],
                            borderWidth: 2,
                            borderColor: `rgba(${color[i]})`,
                            backgroundColor: `rgba(${color[i]}, 0.3)`,
                            tension: 0.3,
                          };
                        }),
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {["super_user", "admin"].includes(profile?.user_type) && (
              <div className="col-12 mb-3">
                <div className="ar-table-card h-100">
                  <div className="ar-table-head flex-wrap gap-2">
                    <div>
                      <div className="ar-table-title">
                        <span className="icon me-2 pu-title-icon">
                          {"\uf155"}
                        </span>
                        Broker Withdrawals
                      </div>
                      <div className="ar-table-caption">
                        Total Withdrawals made by each broker over the selected
                        period
                      </div>
                    </div>
                  </div>

                  <div className="ar-chart" style={{ height: 440 }}>
                    <Bar
                      datasetIdKey="id"
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                      }}
                      data={{
                        labels: array_date,
                        datasets: data_broker?.map((b, i) => {
                          return {
                            id: 1,
                            label: b.name_en,
                            data:
                              chart_broker
                                ?.find((d) => d.label === b.name_en)
                                ?.chart_withdrawal?.map((e) => e.value) || [],
                            borderWidth: 2,
                            borderColor: `rgba(${color[i]})`,
                            backgroundColor: `rgba(${color[i]}, 0.3)`,
                            tension: 0.3,
                          };
                        }),
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {["super_user", "admin"].includes(profile?.user_type) && (
              <div className="col-12 col-xl-6 mb-3">
                <div className="ar-table-card h-100">
                  <div className="ar-table-head flex-wrap gap-2">
                    <div>
                      <div className="ar-table-title">
                        <span className="icon me-2 pu-title-icon">
                          {"\uf0c0"}
                        </span>
                        Top 10 Brokers
                      </div>
                      <div className="ar-table-caption">
                        Highest performing brokers by volume
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover ar-table pu-table pu-table-compact">
                      <thead>
                        <tr>
                          <td className="wpx-50 text-center">#</td>
                          <td className="text-nowrap">Broker</td>
                          <td className="text-end text-nowrap">Deposits</td>
                          <td className="text-end text-nowrap">Withdrawals</td>
                          <td className="text-end text-nowrap">Balance</td>
                        </tr>
                      </thead>
                      <tbody>
                        {data_broker?.slice(0, 10)?.map((item, index) => (
                          <tr key={`array-${index}`}>
                            <td data-label="#" className="text-center">
                              {index + 1}
                            </td>
                            <td data-label="Broker" className="text-nowrap">
                              {item.name_en || item.name_th || "-"}
                            </td>
                            <td
                              data-label="Deposits"
                              className="text-end text-nowrap py-1"
                            >
                              <div>
                                <div style={{ height: 14 }}>
                                  <Countup
                                    start={0}
                                    end={
                                      item.gateway_active?.find(
                                        (e) => e.currency === filter_currency,
                                      )?.total_deposits || 0
                                    }
                                    duration={2}
                                    separator=","
                                  />
                                </div>
                                <small
                                  className={
                                    item.gateway_active?.find(
                                      (e) => e.currency === filter_currency,
                                    )?.order_deposits
                                      ? "text-primary"
                                      : "text-secondary"
                                  }
                                >
                                  <Countup
                                    start={0}
                                    end={
                                      item.gateway_active?.find(
                                        (e) => e.currency === filter_currency,
                                      )?.order_deposits
                                    }
                                    duration={2}
                                    separator=","
                                  />{" "}
                                  orders
                                </small>
                              </div>
                            </td>
                            <td
                              data-label="Withdrawals"
                              className="text-end text-nowrap py-1"
                            >
                              <div>
                                <div style={{ height: 14 }}>
                                  <Countup
                                    start={0}
                                    end={
                                      item.gateway_active?.find(
                                        (e) => e.currency === filter_currency,
                                      )?.total_withdrawals || 0
                                    }
                                    duration={2}
                                    separator=","
                                  />
                                </div>
                                <small
                                  className={
                                    item.gateway_active?.find(
                                      (e) => e.currency === filter_currency,
                                    )?.order_withdrawals
                                      ? "text-primary"
                                      : "text-secondary"
                                  }
                                >
                                  <Countup
                                    start={0}
                                    end={
                                      item.gateway_active?.find(
                                        (e) => e.currency === filter_currency,
                                      )?.order_withdrawals
                                    }
                                    duration={2}
                                    separator=","
                                  />{" "}
                                  orders
                                </small>
                              </div>
                            </td>
                            <td
                              data-label="Balance"
                              className="text-end text-nowrap"
                            >
                              <Countup
                                start={0}
                                end={
                                  item.wallets?.find(
                                    (e) => e.currency === filter_currency,
                                  )?.balance
                                }
                                duration={2}
                                separator=","
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            <div
              className={
                ["super_user", "admin"].includes(profile?.user_type)
                  ? "col-12 col-xl-6 mb-3"
                  : "col-12 mb-3"
              }
            >
              <div className="ar-table-card h-100">
                <div className="ar-table-head flex-wrap gap-2">
                  <div>
                    <div className="ar-table-title">
                      <span className="icon me-2 pu-title-icon">
                        {"\uf0c0"}
                      </span>
                      Top 10 Customers
                    </div>
                    <div className="ar-table-caption">
                      Highest volume customers
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover ar-table pu-table pu-table-compact">
                    <thead>
                      <tr>
                        <td className="wpx-50 text-center">#</td>
                        <td className="text-nowrap">UID</td>
                        <td className="text-nowrap">Customer</td>
                        <td className="text-end text-nowrap">Deposits</td>
                        <td className="text-end text-nowrap">Withdrawals</td>
                      </tr>
                    </thead>
                    <tbody>
                      {data_customer?.map((item, index) => (
                        <tr key={`array-${index}`}>
                          <td data-label="#" className="text-center">
                            {index + 1}
                          </td>
                          <td data-label="UID" className="text-nowrap">
                            <div className="d-flex justify-content-between align-items-center">
                              {item.uid ? item.uid.slice(0, 12) + "..." : "-"}
                              <span
                                className="icon pointer ms-2"
                                title="Copy"
                                onClick={() => {
                                  copyText(item.uid || "");
                                }}
                              >
                                {"\uf0c5"}
                              </span>
                            </div>
                          </td>
                          <td
                            data-label="Customer"
                            className="text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                {item.name_en || item.name_th || "-"}
                              </div>
                              <small className="text-secondary">
                                {item.broker?.name_en ||
                                  item.broker?.name_th ||
                                  "-"}
                              </small>
                            </div>
                          </td>
                          <td
                            data-label="Deposits"
                            className="text-end text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                {toFixed(item.total_deposits, 2) || "0.00"}
                              </div>
                              <small
                                className={
                                  item.order_deposits
                                    ? "text-primary"
                                    : "text-secondary"
                                }
                              >
                                {item.order_deposits || 0} orders
                              </small>
                            </div>
                          </td>
                          <td
                            data-label="Withdrawals"
                            className="text-end text-nowrap py-1"
                          >
                            <div>
                              <div style={{ height: 14 }}>
                                {toFixed(item.total_withdrawals, 2) || "0.00"}
                              </div>
                              <small
                                className={
                                  item.order_withdrawals
                                    ? "text-primary"
                                    : "text-secondary"
                                }
                              >
                                {item.order_withdrawals || 0} orders
                              </small>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {profile?.user_type === "super_user" && (
            <div className="ar-table-card overflow-hidden">
              <iframe
                title="Revenues Table"
                src="https://cloudwatch.amazonaws.com/dashboard.html?dashboard=PaymentBroker&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTQxODI5NTcxMDg3NCIsIlUiOiJ1cy1lYXN0LTFfOG9vdWZpMTE5IiwiQyI6IjV0NDNlbWEwN3J0cXNpZnM2NDZmMWpxdTRhIiwiSSI6InVzLWVhc3QtMTozMDYzMWY2Mi1lODM1LTQ3YmQtOGMxNC0wYzNlYzg0ZWY5NTkiLCJNIjoiUHVibGljIn0%3D"
                style={{ width: "100%", height: "600px", border: "none" }}
              ></iframe>
            </div>
          )}
        </div>
      </div>
    );
  }
}
